<!--component html goes here -->
<!-- <div class="modal-header">
    <button class="btn-close" (click)="cancel()">
        <span></span>
        <span></span>
    </button>
</div> -->
<div class="modal-body">
    <button class="btn-close" (click)="cancel()">
        <span></span>
        <span></span>
    </button>
    <div class="container">
        <form class="form-horizontal">
            <div class="row adresse">
                <div class="col-sm-10 col-sm-offset-2">
                    <h3 *ngIf="!address.id" class="text-center">Nouvelle adresse</h3>
                    <h3 *ngIf="address.id" class="text-center">Modification d'adresse</h3>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">Adresse</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" name="address" [(ngModel)]="address.address" placeholder="Saisissez l'adresse postale"
                        (setAddress)="getAddress($event)" (keyup)="address.streetName='';address.streetNumber='';address.city='';address.postalCode=''"
                        googleplace>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">Numéro
                    <span class="required"> * </span>
                </label>
                <div class="col-sm-10 add-margin">
                    <input type="text" name="streetNumber" [(ngModel)]="address.streetNumber" (keyup)="addressErreur.streetNumber=false"
                        placeholder="Numéro" class="form-control">
                    <span class="required" *ngIf="addressErreur.streetNumber">Merci de saisir un numéro</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label" style="text-align:right;">Nom de la rue
                    <span class="required"> * </span>
                </label>
                <div class="col-sm-10">
                    <input type="text" name="streetName" [(ngModel)]="address.streetName" (keyup)="addressErreur.streetName=false"
                        placeholder="Adresse" class="form-control">
                    <span class="required" *ngIf="addressErreur.streetName">Merci de saisir une adresse</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">Code postale
                    <span class="required"> * </span>
                </label>
                <div class="col-md-10 add-margin">
                    <input type="text" name="postalCode" [(ngModel)]="address.postalCode" (keyup)="addressErreur.postalCode=false"
                        placeholder="Code postale" class="form-control">
                    <span class="required" *ngIf="addressErreur.postalCode">Merci de saisir un code postale</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label" style="text-align:right;">Ville
                    <span class="required"> * </span>
                </label>
                <div class="col-md-10">
                    <input type="text" name="city" [(ngModel)]="address.city" (keyup)="addressErreur.city=false"
                        placeholder="Ville" class="form-control">
                    <span class="required" *ngIf="addressErreur.city">Merci de saisir une ville</span>
                </div>
            </div>
            <div class="form-group">
                <label class="control-label col-md-2">Batiment</label>
                <div class="col-md-1 add-margin">
                    <input type="text" [(ngModel)]="address.building" name="building" class="form-control">
                </div>
                <label class="control-label col-md-2">Escalier</label>
                <div class="col-md-1 add-margin">
                    <input type="text" [(ngModel)]="address.staircase" name="staircase" class="form-control">
                </div>
                <label class="control-label col-md-2">Etage</label>
                <div class="col-md-1 add-margin">
                    <input type="text" [(ngModel)]="address.floor" name="floor" class="form-control">
                </div>
                <label class="control-label col-md-2">Porte</label>
                <div class="col-md-1 add-margin">
                    <input type="text" [(ngModel)]="address.door" name="door" class="form-control">
                </div>
            </div>
            <div class="form-group">
                <label class="control-label col-md-2">Code</label>
                <div class="col-md-1 add-margin">
                    <input type="text" [(ngModel)]="address.inputCode" name="inputCode" class="form-control">
                </div>
                <label class="control-label col-md-2">Interphone</label>
                <div class="col-md-1 add-margin">
                    <input type="text" [(ngModel)]="address.intercom" name="intercom" class="form-control">
                </div>
                <label class="control-label col-md-2">Compléments</label>
                <div class="col-md-4 add-margin">
                    <input type="text" [(ngModel)]="address.complementAddress" name="complementAddress" class="form-control">
                </div>
            </div>
        </form>
        <!-- <div class="footer">
            <button *ngIf="!address.id" type="submit" class="btn" (click)="validate()">
                <i class="flaticon-tick"></i>
                <span>Valider</span>
            </button>
            <button (click)="validate()" *ngIf="address.id" type="submit" class="btn">
                <i class="flaticon-tick"></i>
                <span>Modifier</span>
            </button>
        </div> -->
        <!-- <button *ngIf="!address.id" type="submit" class="btn" (click)="validate()">
            <i class="flaticon-tick"></i>
            <span>Valider</span>
        </button>
        <button (click)="validate()" *ngIf="address.id" type="submit" class="btn">
            <i class="flaticon-tick"></i>
            <span>Modifier</span>
        </button> -->
    </div>
</div>
<div class="text-center validate">
        <button (click)="validate()">
            <p *ngIf="!address.id">valider</p>
            <p *ngIf="address.id">Modifier</p>
        </button>
    </div>
    